import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Case, EvidenceRequirement } from "../singleCase/types/Case";
import { CustomerEvidenceRequest } from "../singleCase/types/CustomerEvidence";
import { CasesState } from "./types/CasesState";
import { EvidenceError } from "./types/EvidenceError";
import { clearEvidenceError, mergeEvidenceError } from "./utils";

const initialState: CasesState = {
  loading: true,
  error: "",
  cases: [],
  currentEvidence: {
    outbound: {
      message: {
        loading: false,
        error: undefined,
      },
      upload: {
        loading: false,
        error: undefined,
      },
      files: {
        data: [],
        loading: false,
        error: undefined,
      },
      errors: [],
    },
    inbound: {
      files: {
        data: [],
        error: undefined,
        loading: false,
      },
    },
  },
};

const mergeUpdatedEvidence = (cases: Case[], payload: EvidenceRequirement) => {
  return cases.map((caseItem) => {
    caseItem.evidences = caseItem.evidences.map((evidenceItem) => {
      if (evidenceItem.evidenceId === payload.evidenceId) {
        return payload;
      }
      return evidenceItem;
    });
    return caseItem;
  });
};

const casesSlice = createSlice({
  name: "cases",
  initialState,
  reducers: {
    requestCases: (state, action: PayloadAction) => {
      state.loading = true;
    },
    requestCasesSuccessful: (state, action: PayloadAction<Case[]>) => {
      state.loading = false;
      state.cases = action.payload;
    },
    requestCasesFailed: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    requestSubmitEvidence: (
      state,
      action: PayloadAction<CustomerEvidenceRequest>,
    ) => {
      state.currentEvidence.outbound.message.loading = true;
      state.currentEvidence.outbound.message.error = undefined;

      state.currentEvidence.outbound.errors = clearEvidenceError(
        state.currentEvidence.outbound.errors,
        action.payload.evidenceId,
      );
    },
    requestSubmitEvidenceSuccessful: (state, action: PayloadAction<any>) => {
      state.currentEvidence.outbound.message.loading = false;
      state.cases = mergeUpdatedEvidence(state.cases, action.payload);
    },
    requestSubmitEvidenceFailed: (
      state,
      action: PayloadAction<EvidenceError>,
    ) => {
      state.currentEvidence.outbound.message.loading = false;

      state.currentEvidence.outbound.errors = mergeEvidenceError(
        state.currentEvidence.outbound.errors,
        action.payload,
      );
    },
    requestDocumentFromEvidence: (state, action: PayloadAction<any>) => {
      state.currentEvidence.inbound.files.loading = true;
    },
    requestToggleEvidenceRead: (
      state,
      action: PayloadAction<{
        caseId: string;
        evidenceId: string;
        read: boolean;
      }>,
    ) => {
      // Currently no action taken.
    },
    requestToggleEvidenceReadSuccessful: (
      state,
      action: PayloadAction<EvidenceRequirement>,
    ) => {
      state.cases = mergeUpdatedEvidence(state.cases, action.payload);
    },
    requestToggleEvidenceReadFailed: (state, action: PayloadAction<string>) => {
      // Currently no action taken.
      // Saga will attempt request 5 times, if this
      // failure action occurs then we simply try again next time.
    },
  },
});

export const { actions } = casesSlice;
export const {
  requestCases,
  requestSubmitEvidence,
  requestToggleEvidenceRead,
} = actions;
export default casesSlice.reducer;
